import { Icon } from 'utils'

const ClockSvg = () => {
  return (
    <div className="mr-2">
      <Icon
        className="btn-tertiary"
        role="presentation"
        id="#clock"
        width="22"
        height="22"
        fill="#006ba6"
      />
    </div>
  )
}

export default ClockSvg
